import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ensureLocalSeedData } from './services/shipmentService';
import './styles/global.css';

ensureLocalSeedData();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

